/**
 * Firm-wide safeguards an admin can turn on (OL-152). Each is a boolean
 * global setting, off by default. The backend also returns them on the signed-in
 * user as `security`, which is what the rest of the app reads.
 */
export const SECURITY_SWITCHES = [
  {
    key: 'export_approval',
    icon: 'file-down',
    title: 'Exports require approval',
    description:
      'Staff downloads of lists and reports (contacts, matters, invoices, AR and ad-hoc reports) go to an administrator for approval first. Approved exports can be downloaded once, within 24 hours, from Export Requests. Administrators and anyone with Approve Export Requests export directly.',
  },
  {
    key: 'bulk_delete_admins_only',
    icon: 'trash',
    title: 'Only administrators can delete in bulk',
    description:
      'Hides "Delete Selected" from everyone but administrators. Staff with a Delete permission can still delete one record at a time. Deleted records go to the Recycle Bin either way.',
  },
  {
    key: 'alert_admins_sensitive_actions',
    icon: 'notification-on',
    title: 'Email administrators about exports and bulk deletes',
    description:
      'Every time someone downloads a list or report, or deletes records in bulk, the other administrators get a notification and an email. Everything is recorded in the Audit Log either way.',
  },
  {
    key: 'require_two_factor',
    icon: 'shield-tick',
    title: 'Require two-factor authentication',
    description:
      'Everyone must turn on 2FA (an authenticator app code at sign-in). People who have not will only be able to reach Account → Security until they do. Check that you have 2FA on yourself before switching this on.',
  },
];

/** The switches' current values from a settings payload, as the `security` object on the user. */
export const pickSecurity = (settings) =>
  Object.fromEntries(SECURITY_SWITCHES.map(({ key }) => [key, settings?.[key] === true]));
